// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-gIIxpLcz","title":"dp-T9c7gl4f","desc":"dp-k9wPEoSI","bottomContainer":"dp-adqPvJCR","itemContainer":"dp-ByFre8xu","arrow":"dp-oJjMk6p2"};